<template>
  <div class="substep-smart-notifications substep-automate-detecting-unusual-activities">
    <div class="substep-header">
      <h3 data-testid="insights-onboarding-substep-title">Automate detecting unusual activities</h3>
      <p>Set up smart notifications to get notified automatically as soon as the activity you're interested in happens.</p>
    </div>
    <div class="substep-body">
      <div>
        <h4>{{ title }}</h4>
        <p>This will catch the suspicious application you saw on the previous page.</p>
      </div>

      <div class="notifications-cards">
        <div
          v-for="(card, index) in notificationTemplates"
          :key="card.key"
          class="notification-card"
        >
          <img
            :src="card.src"
            :alt="card.label"
            class="card-image"
          />

          <div class="card-wrapper">
            <h3 class="card-title">
              {{ card.label }}
            </h3>
            <div class="card-description">
              <p>{{ card.description }}</p>
            </div>
            <div class="card-triggers">
              <div class="trigger">
                <img
                  title="Frequency of notification"
                  :src="assets.triggers.ICON_WATCH"
                  :alt="card.frequency"
                />
                <span>{{ card.frequency }}</span>
              </div>
              <div class="trigger">
                <img
                  title="Notification platform"
                  :src="assets.triggers.ICON_BELL"
                  alt="Email"
                />
                <span>Email</span>
              </div>
            </div>
            <div class="card-footer">
              <div v-if="!notificationExists(card.label)">
                <AppButton
                  :disabled="submitting[index]"
                  type="outline"
                  @click="createNotification(card, index)"
                >
                  Create
                </AppButton>
              </div>
              <div v-else>
                <AppButton
                  v-if="userIsAuthor"
                  :disabled="submitting[index]"
                  type="outline-success"
                  @click="deleteNotification(card, index)"
                >
                  Created
                  <i class="hi hi-check hi-12"></i>
                </AppButton>
                <div
                  v-else
                  class="card-footer"
                >
                  <div class="created">
                    Created
                    <i class="hi hi-check-circle hi-18"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppButton from '~/components/AppButton.vue';
import SmartNotificationWizardMixin from '~/mixins/GrowthWizard/SmartNotificationWizardMixin';
import { SETTINGS_SMART_NOTIFICATIONS } from '~/app_constants';

export default {
  name: 'AutomateDetectingUnusualActivities',
  components: {
    AppButton,
  },
  mixins: [SmartNotificationWizardMixin],
  data() {
    return {
      notificationPresets: ['suspicious_application_autoclicker'],
    };
  },
  computed: {
    title() {
      return !this.notificationExists(this.getTemplateName()) || this.userIsAuthor ?
        "Let's create your first smart notification in 1 minute or less. ⏱️" :
        'Great! Someone else in your organization already set this up.';
    },
    userIsAuthor() {
      return this.findNotification()?.is_author === true || false;
    },
  },
  methods: {
    findNotification() {
      const notification = this.notifications.find((notification) => notification.name === this.getTemplateName());

      return notification || null;
    },
    getTemplateName() {
      return SETTINGS_SMART_NOTIFICATIONS.presets.suspicious_application_autoclicker.name;
    },
  },
};
</script>
